import { inject, InjectionToken, Provider } from '@angular/core';
import { DocumentTypesSignalState } from '../../types/document-types.signal-state.type';
import { DOCUMENT_TYPES_SIGNAL_STORE } from '../signal-store/document-types.signal-store';

/**
 * Injection token for the document types admin signal store
 */

export const DOCUMENT_TYPES_TOKEN =
  new InjectionToken<DocumentTypesSignalState>(
    'Document Types Admin Initial State',
  );

/**
 * Provider for the document types admin signal store
 */
export const DOCUMENT_TYPES_PROVIDER: Provider = {
  provide: DOCUMENT_TYPES_TOKEN,
  useClass: DOCUMENT_TYPES_SIGNAL_STORE,
};

/**
 * Document Types Admin Tokenizer - provides the document types admin signal store instance
 */

export function documentTypesTokenizer() {
  return inject(DOCUMENT_TYPES_TOKEN);
}
